import { $http, buildHeaders } from "./index";

//获取验证码
export const login_captcha = () => {
  return $http.get("/admin/Login/captcha", {
    headers: {
      unAuth: true,
    },
  });
};

//登录验证
export const login_doLogin = (data) => {
  return $http.post("/admin/Login/doLogin", data, {
    headers: {
      ...buildHeaders(3, "正在验证登录信息，请稍后……"),
      unAuth: true,
    },
  });
};
